import React, { useState } from "react";
import { CONTACT_EMAIL } from "./SiteFooter";

type FormErrors = {
  name?: string;
  contact?: string;
  message?: string;
};

type FormState = "idle" | "submitting" | "success" | "error";

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState<FormErrors>({});
  const [formState, setFormState] = useState<FormState>("idle");

  const validate = () => {
    const nextErrors: FormErrors = {};
    if (!name.trim()) nextErrors.name = "Bitte geben Sie Ihren Namen ein.";
    if (!email.trim() && !phone.trim()) nextErrors.contact = "Bitte geben Sie eine E-Mail-Adresse oder Telefonnummer an.";
    if (!message.trim()) nextErrors.message = "Bitte beschreiben Sie kurz Ihre Vermietung oder Ihren Anwendungsfall.";
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!validate()) return;

    setFormState("submitting");
    try {
      const response = await fetch("/contact-submission", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name.trim(),
          mail: email.trim(),
          phone_number: phone.trim(),
          message: message.trim(),
        }),
      });

      if (!response.ok) throw new Error(`Kontaktanfrage fehlgeschlagen: ${response.status}`);
      setFormState("success");
    } catch (error) {
      console.error(error);
      setFormState("error");
    }
  };

  return (
    <section className="contact-section" id="kontakt" aria-labelledby="contact-title">
      <div className="contact-glow" aria-hidden="true" />
      <div className="section-shell contact-layout">
        <div className="contact-copy">
          <p className="eyebrow light">Beta-Programm</p>
          <h2 id="contact-title">Werden Sie Beta-Kunde und gestalten Sie mit.</h2>
          <p>Gatai ist im Einsatz und wird gemeinsam mit ausgewählten Autovermietungen weiterentwickelt – nah an echten Abläufen, von der Briefpost bis zur Fahrerbenennung. Als Beta-Kunde richten wir Ihren Zugang persönlich ein und Sie nehmen direkt Einfluss auf die nächsten Funktionen.</p>
        </div>

        <div className="contact-card">
          {formState === "success" ? (
            <div className="form-success" role="status">
              <span className="success-mark" aria-hidden="true">✓</span>
              <p className="eyebrow">Anfrage gesendet</p>
              <h3>Vielen Dank, {name.split(" ")[0]}.</h3>
              <p>Ihre Nachricht ist angekommen. Wir melden uns kurzfristig über den angegebenen Kontaktweg.</p>
              <button type="button" className="button button-light" onClick={() => setFormState("idle")}>Weitere Nachricht senden</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} noValidate>
              <div className="form-heading">
                <span>Kostenlose Live-Demo sichern</span>
              </div>
              <div className="field full-field">
                <label htmlFor="name">Name <span>*</span></label>
                <input id="name" name="name" type="text" autoComplete="name" value={name} onChange={(event) => setName(event.target.value)} aria-invalid={Boolean(errors.name)} aria-describedby={errors.name ? "name-error" : undefined} placeholder="Vor- und Nachname" />
                {errors.name && <small className="field-error" id="name-error">{errors.name}</small>}
              </div>
              <div className="form-row">
                <div className="field">
                  <label htmlFor="email">E-Mail</label>
                  <input id="email" name="email" type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} aria-invalid={Boolean(errors.contact)} placeholder="name@unternehmen.de" />
                </div>
                <div className="field">
                  <label htmlFor="phone">Telefon</label>
                  <input id="phone" name="phone" type="tel" autoComplete="tel" value={phone} onChange={(event) => setPhone(event.target.value)} aria-invalid={Boolean(errors.contact)} placeholder="030 12345678" />
                </div>
              </div>
              {errors.contact && <small className="field-error contact-error">{errors.contact}</small>}
              <div className="field full-field">
                <label htmlFor="message">Wobei können wir helfen? <span>*</span></label>
                <textarea id="message" name="message" rows={5} value={message} onChange={(event) => setMessage(event.target.value)} aria-invalid={Boolean(errors.message)} aria-describedby={errors.message ? "message-error" : undefined} placeholder="Zum Beispiel: Wir vermieten 60 Fahrzeuge und bearbeiten pro Woche rund 15 Bußgeldbescheide von Hand." />
                {errors.message && <small className="field-error" id="message-error">{errors.message}</small>}
              </div>
              {formState === "error" && <p className="form-error" role="alert">Die Anfrage konnte gerade nicht gesendet werden. Bitte versuchen Sie es erneut oder schreiben Sie an {CONTACT_EMAIL}.</p>}
              <button className="button button-dark submit-button" type="submit" disabled={formState === "submitting"}>
                {formState === "submitting" ? "Wird gesendet …" : "Absenden"}
                <span aria-hidden="true">→</span>
              </button>
              <p className="privacy-note">Mit dem Absenden werden Ihre Angaben zur Bearbeitung der Anfrage verarbeitet. Weitere Informationen finden Sie in der <a href="/Datenschutz">Datenschutzerklärung</a>.</p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}

export default Contact;
